/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import type { ContextRouter } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import {
  Row,
  Col,
  Layout,
} from 'antd';
import {
  AccountSetupWrapper,
  PaymentFormWrapper,
} from 'components/DesignKit';

import {
  notificationActions,
  businessActions,
} from 'store/actions';

import {
  PAGES,
  TOKENS,
} from 'appconstants';
import PaymentClose from 'components/NavIcons/paymentClose';
import LogoNew from 'components/NavIcons/LogoNew';
import { Img } from 'design';
import SwirepayLogo from '../../assets/imgs/swirepay-logo.svg';
import IndividualIcon from '../../assets/imgs/Account_Select_Individual.svg';
import BusinessIcon from '../../assets/imgs/Account_Type_Business.svg';
import ConfirmationModal from './components/ConfirmationModal';

// import ReviewPaymentPage from './components/ReviewPaymentPage';

const useQuery = () => new URLSearchParams(useLocation().search);

// const { Step } = Steps;
const { Header } = Layout;

type Props = ContextRouter & {
  selectedAccount: Object,
  validator: boolean,
  loading: boolean,
  history: {
    replace: Function,
  },
};

const AccountSetup = (props: Props) => {
  const {
    history,
  } = props;
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const query = useQuery();
  const affiliateCode = query.get('affiliate_code');
  const referralCode = query.get('referral_code');

  const backtoLogin = () => {
    localStorage.removeItem(TOKENS.ACCESS_TOKEN);
    localStorage.removeItem(TOKENS.REFERRAL_CODE);
    localStorage.removeItem('dynamicStaticQr');
    localStorage.removeItem('fcmToken');
    history.replace(PAGES.LOGIN);
  };

  const onClose = (e) => {
    e.preventDefault();
    history.replace(PAGES.LOGIN);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (affiliateCode) {
      history.replace(`${PAGES.ACCOUNT}?accountType=${selectedType}&affiliate_code=${affiliateCode}`);
    } else if (referralCode) {
      history.replace(`${PAGES.ACCOUNT}?accountType=${selectedType}&referral_code=${referralCode}`);
    } else {
      history.replace(`${PAGES.ACCOUNT}?accountType=${selectedType}`);
    }
  };

  return (
    <Layout style={{ marginLeft: '0px', minHeight: '0px' }}>
      <Header style={{ color: '#fff', fontSize: '20px', background: '#18294c !important' }}>
        <Row type="flex" justify="space-between">
          <Col className="d-flex align-items-center">
            <LogoNew />
          </Col>
          <Col className="d-flex align-items-center justify-content-end">
            <span style={{ cursor: 'pointer' }} onClick={() => backtoLogin()}>
              <PaymentClose />
            </span>
          </Col>
        </Row>
      </Header>
      <AccountSetupWrapper>
        <PaymentFormWrapper style={{ width: '800px' }} className="mt-3">
          <div>
            <Row type="flex" justify="center" className="p-4" style={{ borderRadius: '10px', backgroundColor: 'white' }}>
              <Col>
                <Img src={SwirepayLogo} width="180" />
              </Col>
            </Row>
            <Row gutter={16} className="d-flex justify-content-center mt-4">
              <Col span={10}>
                <div
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: '#F2F5F8',
                    width: '300px', // or adjust as per your grid
                    height: '320px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'transform 0.3s',
                  }}
                  onClick={() => { setOpen(true); setSelectedType('INDIVIDUAL'); }}
                >
                  <div
                    style={{
                      backgroundColor: '#007ED4',
                      color: '#fff',
                      textAlign: 'center',
                      fontSize: '2rem',
                      padding: '16px 0',
                    }}
                  >
                    Individual
                  </div>
                  <div
                    style={{
                      padding: '32px 16px',
                      textAlign: 'center',
                    }}
                  >
                    <div style={{ fontSize: '1.2rem', fontWeight: '500', marginBottom: '2rem' }}>
                      *For Sole Proprietorship or similar
                    </div>
                    <img src={IndividualIcon} alt="Individual" width="100" />
                  </div>
                </div>
              </Col>
              <Col span={10}>
                <div
                  style={{
                    borderRadius: '20px',
                    // backgroundColor: '#F2F5F8',
                    width: '300px', // or adjust as per your grid
                    height: '320px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    transition: 'transform 0.3s',
                  }}
                  onClick={() => { setOpen(true); setSelectedType('BUSINESS'); }}
                >
                  <div
                    style={{
                      backgroundColor: '#007ED4',
                      color: '#fff',
                      textAlign: 'center',
                      fontSize: '2rem',
                      padding: '16px 0',
                    }}
                  >
                    Business
                  </div>
                  <div
                    style={{
                      padding: '32px 16px',
                      textAlign: 'center',
                    }}
                  >
                    <img style={{ marginTop: '2rem' }} src={BusinessIcon} alt="Individual" width="100" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {open && (
            <ConfirmationModal
              visible={open}
              selectedType={selectedType}
              cancel={onClose}
              submit={onSubmit}
              closeModal={() => setOpen(false)}
            />
          )}
        </PaymentFormWrapper>
      </AccountSetupWrapper>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  selectedAccount: state.account.accounts,
  paymentPagesDetails: state.paymentPagesDetails,
  paymentPagesDetailsStatus: state.paymentPagesDetails.paymentPagesDetailsStatus,
  accountSlug: state.accountSlug.content,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  addBusinessSignUp: (gid, param) => dispatch(businessActions.addBusinessSignUp({
    gid,
    param,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSetup);
